module.exports = __webpack_public_path__ + "img/main_xhj.e3ec46bd.jpg";